<template>
    <div class="toolbar">
        <div :class="item.falg?'bars selected':'bars' " v-for="item in bars" :key="item.id" :title="item.bar" @click="selectMenu(item)">
            <img :src="item.falg?item.img:item.img2" alt="">
        </div>
    </div>
</template>

<script>
import url from '../../assets/img/water.jpg'
export default {
    data(){
        return {
            url,
            primitiveArr:[],  // primitive类
            bars:[
                {
                    id:1,
                    bar:"主视角",
                    falg:false,
                    img:require('../../assets/img/bimicon_1.png'),
                    img2:require('../../assets/img/bimicon.png')
                },
                {
                    id:2,
                    bar:"裁切",
                    falg:false,
                    img:require('../../assets/img/bimicon-07.png'),
                    img2:require('../../assets/img/bimicon-08.png'),
                },
                {
                    id:3,
                    bar:"旋转",
                    falg:false,
                    img:require('../../assets/img/bimicon-23.png'),
                    img2:require('../../assets/img/bimicon-24.png'),
                },
                {
                    id:4,
                    bar:"漫游",
                    falg:false,
                    img:require('../../assets/img/bimicon-09.png'),
                    img2:require('../../assets/img/bimicon-10.png'),
                },
                // {
                //     id:5,
                //     bar:"波纹效果",
                //     falg:false,
                //     img:require('../../assets/img/bimicon-25.png'),
                //     img2:require('../../assets/img/bimicon-26.png'),
                // },
                {
                    id:6,
                    bar:"测距",
                    falg:false,
                    img:require('../../assets/img/bimicon-05.png'),
                    img2:require('../../assets/img/bimicon-06.png'),
                },
            ],
            homeView:{
                x: -2331090.100839201,
                y: 4656628.2587722065,
                z: 3670610.0484654326,
                heading:6.272933419640759,
                pitch:-0.27094197093883965,
                roll:6.283184446243114
            }
        }
    },
    methods:{
        selectMenu(menu){
            this.reset(menu)
            let _this = this
            menu.falg = !menu.falg
            switch(menu.id){
                case 1: // 主视角
                    // if(convenient){
                    //     convenient.fly(_this.homeView)
                    // }
                    this.$emit('selectMenu', menu)
                    break;
                case 2:  // 裁切
                    this.$emit('selectMenu', menu)
                    break;
                case 3:  // 旋转
                    this.$emit('selectMenu', menu)
                    break;
                case 4:  // 漫游
                    console.log("漫游");
                    if(menu.falg){
                        _this.freeden()
                    }else {
                        _this.quit()
                    }
                    break;
                case 5:  // 水波纹
                    console.log("水波纹");
                    if(menu.falg){
                        _this.addWater()
                    }else{
                        _this.removeWater()
                    }
                    break;
                case 6:  // 测量
                    console.log("测量");
                    this.$emit('selectMenu', menu)
                    break;
            }
        },
        reset(menu){
            let _this = this
            this.bars.forEach(item =>{
                if(item.bar !== menu.bar){
                    item.falg = false
                    this.$emit('selectMenu', item)
                }
            })
            this.removeWater()
            _this.quit()
        },
        freeden(){
            let ellipsoid = viewer.scene.globe.ellipsoid;

            viewer.scene.screenSpaceCameraController.enableRotate = false;
            viewer.scene.screenSpaceCameraController.enableTranslate = false;
            viewer.scene.screenSpaceCameraController.enableZoom = false;
            viewer.scene.screenSpaceCameraController.enableTilt = false;
            viewer.scene.screenSpaceCameraController.enableLook = false;

            let startMousePosition;
            let mousePosition;
            let flags = {
                looking : false,
                moveForward : false,
                moveBackward : false,
                moveUp : false,
                moveDown : false,
                moveLeft : false,
                moveRight : false
            };

            viewer.screenSpaceEventHandler.setInputAction(function(movement) {
                flags.looking = true;
                mousePosition = startMousePosition = Cesium.Cartesian3.clone(movement.position);
            }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

            viewer.screenSpaceEventHandler.setInputAction(function(movement) {
                mousePosition = movement.endPosition;
            }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

            viewer.screenSpaceEventHandler.setInputAction(function(position) {
                flags.looking = false;
            }, Cesium.ScreenSpaceEventType.LEFT_UP);

            function getFlagForKeyCode(keyCode) {
                switch (keyCode) {
                case 'W'.charCodeAt(0):
                    return 'moveForward';
                case 'S'.charCodeAt(0):
                    return 'moveBackward';
                case 'Q'.charCodeAt(0):
                    return 'moveUp';
                case 'E'.charCodeAt(0):
                    return 'moveDown';
                case 'D'.charCodeAt(0):
                    return 'moveRight';
                case 'A'.charCodeAt(0):
                    return 'moveLeft';
                default:
                    return undefined;
                }
            }

            document.addEventListener('keydown', this.down = function(e){
                let flagName = getFlagForKeyCode(e.keyCode);
                if (typeof flagName !== 'undefined') {
                    flags[flagName] = true;
                }
            }, false);

            document.addEventListener('keyup', this.up =(e)=>{
                let flagName = getFlagForKeyCode(e.keyCode);
                if (typeof flagName !== 'undefined') {
                    flags[flagName] = false;
                }
            }, false);

            viewer.clock.onTick.addEventListener(function(clock) {
                let camera = viewer.camera;
                // 镜头旋转
                if (flags.looking) {
                    let width = viewer.canvas.clientWidth;
                    let height = viewer.canvas.clientHeight;

                    let lookFactor =0.1;
                    let x = (mousePosition.x - startMousePosition.x) / width;
                    let y = -(mousePosition.y - startMousePosition.y) / height;
                    
                    camera.setView({
                        orientation: {
                            heading : camera.heading + x*lookFactor, 
                            pitch : camera.pitch + y*lookFactor,    
                            roll : 0.0                             
                        }
                    })
                }

                // 根据高度来决定镜头移动的速度
                var cameraHeight = ellipsoid.cartesianToCartographic(camera.position).height;
                var moveRate = cameraHeight / 150.0;

                if (flags.moveForward) {
                    camera.moveForward(moveRate);
                }
                if (flags.moveBackward) {
                    camera.moveBackward(moveRate);
                }
                if (flags.moveUp) {
                    camera.moveUp(moveRate);
                }
                if (flags.moveDown) {
                    camera.moveDown(moveRate);
                }
                if (flags.moveLeft) {
                    camera.moveLeft(moveRate);
                }
                if (flags.moveRight) {
                    camera.moveRight(moveRate);
                }
            });
        },
        quit(){
            viewer.scene.screenSpaceCameraController.enableRotate = true;
            viewer.scene.screenSpaceCameraController.enableTranslate = true;
            viewer.scene.screenSpaceCameraController.enableZoom = true;
            viewer.scene.screenSpaceCameraController.enableTilt = true;
            viewer.scene.screenSpaceCameraController.enableLook = true;
            viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN)
            viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
            viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP)
            document.removeEventListener('keydown',this.down,false)
            document.removeEventListener('keyup',this.up,false)
        },
        addWater(){
            let _this = this
            let water = viewer.scene.primitives.add(
                new Cesium.Primitive({
                    geometryInstances: new Cesium.GeometryInstance({
                        geometry: new Cesium.RectangleGeometry({
                            rectangle: Cesium.Rectangle.fromDegrees(
                                110.16,20.14,
                                110.18,20.16,
                            ),
                            vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
                        }),
                    }),
                    appearance: new Cesium.EllipsoidSurfaceAppearance({
                        material: new Cesium.Material({
                            fabric: {
                                type: "Water",
                                uniforms: {
                                    baseWaterColor: new Cesium.Color(64 / 255.0, 157 / 255.0, 253 / 255.0, 0.5),
                                    normalMap: _this.url,
                                    frequency: 1000.0,
                                    animationSpeed: 0.1,
                                    amplitude: 10,
                                    specularIntensity: 10
                                }
                            }
                        })
                    }),
                })
            );
            this.primitiveArr.push(water)
            convenient.fly({
                x: -2065927.3455220475,
                y: 5623692.337816107,
                z: 2182677.079521227,
                heading:6.178072730801672,
                pitch:-0.9225404997113462,
                roll:3.3735822757563483e-7
            })
        },
        removeWater(){
            if(this.primitiveArr.length > 0){
                this.primitiveArr.forEach(item =>{
                    viewer.scene.primitives.remove(item)
                })
            }
            
        },
    }
}
</script>

<style lang="less" scoped>
    .toolbar{
        position: fixed;
        bottom:5vh;
        height:5vh;
        width: 20vw;
        left: 0;
        right: 0;
        margin: auto;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        background: #000000;
        .bars{
            width: 3vw;
            height: 5vh;
            display: flex;
            justify-content: center;
            align-items: center;
            &>img{
                width: 1.2vw;
                height: 2.5vh;
            }
        }
        .selected{
            background: url('../../assets/img/bimicon-28.png') no-repeat;
            background-size: 100% 100%;
        }
    }
</style>